import { injectable } from 'inversify';
import 'reflect-metadata';
import { Response } from '@/_shared/_api/models/response.model';
import axiosClient from './axios-client';
import { ERRORS } from '../constants/errors/error-messages.constants';
import LogHelper from '../helpers/log.helper';
import { AlertListItem } from '../models/alerts/alert.model';

export interface GetAlertsApiResponse {
  result: AlertListItem[];
  totalCount: number;
  unreadCount: number;
}

@injectable()
export class AlertService {
  logger: LogHelper;

  constructor(logger = new LogHelper()) {
    this.logger = logger;
  }

  async getAlerts(
    offset = 0,
    limit = 20
  ): Promise<Response<GetAlertsApiResponse>> {
    try {
      const response = await axiosClient.get<Response<GetAlertsApiResponse>>(
        '/api/alerts',
        { params: { offset, limit } }
      );
      return response.data;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async markAlertsAsRead(alertIds?: string[]): Promise<Response<unknown>> {
    try {
      const response = await axiosClient.put<Response<unknown>>(
        '/api/alerts',
        alertIds ? { alertIds } : {},
        { headers: { 'Content-Type': 'application/json' } }
      );
      return response.data;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }
}
